// Brand name — change this to your final brand name anytime.
export const BRAND_NAME = "Angel Star Inc";
export const BRAND_TAGLINE = "";
